import { memo } from 'react';

import type { IconProperties } from './types';

interface PlanGroupByRadioIconProperties extends IconProperties {
  checked?: boolean;
}

const PlanGroupByRadioIcon = ({
  width = 18,
  height = 18,
  color = '#8B5CF6',
  checked = false,
}: PlanGroupByRadioIconProperties) =>
  checked ? (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <circle cx='9' cy='9' r='9' fill={color} />
      <path
        d='M5.25 9.25L7.75 11.75L12.75 6.75'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ) : (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <circle cx='9' cy='9' r='8' stroke={color} strokeWidth='1.5' />
    </svg>
  );

export default memo(PlanGroupByRadioIcon);
